import { Grid, Theme } from '@mui/material';
import { PoolTypography } from '@synergy/components';
import { UserRole } from '@synergy/models';
import { createStyles, makeStyles } from '@mui/styles';

import { ContactDetailPermissionsRoleField } from './contact-detail-permissions-role-field';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grid: {
            marginTop: 0,
        },
    })
);

export const ContactDetailPermissionsRolesSulu = () => {
    const classes = useStyles();

    return (
        <>
            <PoolTypography styleType="sectionTitle" id="app.contactsAndOrganizations.contact.portal.sulu" />

            <Grid container={true} className={classes.grid} columnSpacing={2}>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.SuluAdmin} />
                </Grid>
            </Grid>
        </>
    );
};
